import { render, staticRenderFns } from "./enoughsent.vue?vue&type=template&id=0f10b3b8&"
import script from "./enoughsent.vue?vue&type=script&lang=js&"
export * from "./enoughsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports